import React from 'react'
import {browserHistory}  from 'react-router'
import {connect} from 'react-redux'
import {Dialog,Popup} from 'react-weui'
import axios from 'axios'
import Config from '../config'
import qs from 'qs'
import {Link} from 'react-router'
import {renderMoney, printObject, getJsonFromUrl, TimeStream, isPC, getToken, AddRef} from '../utils'

import {
    Preload,
    Page,
    CoverImage,
    DetailTitle,
    LabelBar,
    PageBottomText,
    AudioPlay,
    FollowLiveroom,
    GiftDialogTips2,
    WKError,
    WKToShareCard,
    GiftDialog,
    WKToIndex,
    WKDialog,
    PopularBar,
    ReceiveCoupon,
    AvailableCoupon
} from '../components'
import {
    LectureForm,
    LectureLimitPrice,
    LectureTab,
    LectureBottomNav,
    LecturePayPanel,
    LectureListenTips,
    LectureLecturers,
    LectureLecturersInput,
    LectureLiveroomBar,
    LectureTopLiveroomBar,
} from '../components/lecture'
import {MinaPay} from '../components/mina'

import {WKOperation, WKVisible} from '../components/wk'
import {PushComponent, DeleteComponent, CouponBar, CouponSelected, DeepFocusBar, SVIPBar} from '../components/details'

import Pay from '../components/Pay'

import '../styles/lecture.css'
import '../css/page/LecturePage.css'
import yhq from '../images/yhq-small.png'
import zs from '../images/zs.png'
import EditLecture from '../images/lecture/edit-lecture.png'
import PushLecture from '../images/lecture/push-lecture.png'
import StudentManage from '../images/lecture/student-manage.png'
import DataAna from '../images/lecture/data-ana.png'
import RelaySetting from '../images/lecture/relay-setting.png'
import Coupon from '../images/lecture/coupon.png'
import PersonManage from '../images/lecture/person-manage.png'
import limitImg from '../images/lecture/limit.png'


class LecturePage extends React.Component {
    constructor() {
        super();
        this.onRelayBarClick = this.onRelayBarClick.bind(this);
        this.onPopularBarClick = this.onPopularBarClick.bind(this);
        this.onDiscountBarClick = this.onDiscountBarClick.bind(this);
        this.onChannelClick = this.onChannelClick.bind(this);
        this.onInitComponent = this.onInitComponent.bind(this);
        this.onOpenLectureChat = this.onOpenLectureChat.bind(this);
        this.onOpenGiftBar = this.onOpenGiftBar.bind(this);
        this.onRenderRqb = this.onRenderRqb.bind(this);
        this.handleToShareCard = this.handleToShareCard.bind(this);
        this.handleCloseNewDialog = this.handleCloseNewDialog.bind(this);
        this.scrollCount = 0 // 节流

        this.state = {
            firstEnter: true,
            showLectureNew: false,
            push_show: false,
            delete_show: false,
            shareCardTop: null,
            isShowGift: false,
            isfromResell:false,//从分销过来的蒙层
            confirmStyle: {
                noText: '关闭',
                yesText: '邀请好友',
                clickNoHandle: this.handleCloseNewDialog,
                clickYesHandle: this.handleToShareCard,
            },
            showNormalDialog: false,
            NormalDialogBtns: [
                {
                    type: 'default',
                    label: '暂时不去',
                    onClick: () => {this.setState({showNormalDialog: false})}
                },
                {
                    type: 'primary',
                    label: '现在就去',
                    onClick: () => {location.assign('/account/coupons?auto_focus=1')}
                }
            ],
        };
    }

    handleToShareCard() {
        const {lecture} = this.props.lecture;
        this.setState({showLectureNew: false});
        window.location = `/lecture/${lecture.id}/sharecard`;
    }

    handleCloseNewDialog() {
        this.setState({showLectureNew: false});
    }

    handleHidePush() {
        this.setState({
            push_show: false
        })
    }

    handleHideDelete() {
        this.setState({
            delete_show: false
        })
    }

    componentDidMount() {
        // 解决返回黑屏的问题
        window.scrollTo(0,1)
        window.location.search.indexOf('from=resell')>-1 ? this.setState({isfromResell:true}) : null ;

        let data = this.props.lecture;

        if (data.lecture.lecture_type === 'pay_channel') {
            if (!data.role.is_manager && !data.role.is_lecturer) {
                if (!data.lecture.is_relay) {
                    if (!data.role.is_liveroom_vip) {
                        if (!(data.channel_access.granted || data.lecture_access.granted)) {
                            window.location = `/channel/${data.channel.id}`
                        }
                    }
                } else {
                    if (!(data.channel_access.granted || data.lecture_access.granted) && (data.lecture_access.grant_type !== 'manager')) {
                        window.location = `/channel/${data.channel.id}`
                    }
                }
            }
        }

        if (data.liveroom.id !== 23719500 && data.liveroom.id !== 23697056 && !data.role.is_manager){
            AddRef()
        }

        let {lecture_id} = this.props.params;

        if(Config.REDIRECT_WARN){
            if(  data.lecture.risk_level == 'warning' && window.location.origin != Config.WARNING_URL){
                let params = qs.parse(window.location.search.substr(1))
                params.__token = getToken()
                window.location.href =  Config.WARNING_URL + window.location.pathname  + '?' + qs.stringify(params)
            }
        }

        document.title = data.lecture.name;


        if (data.lecture.lecture_type === 'pay_channel') {
            this.props.dispatch({
                type: 'LECTURE_SET_SINGLE_CHANNEL_PAY'
            })
        }

        // 设置专栏付费，同步选择
        if (data.channel && data.channel.need_money) {
            // 特例代码（特定专栏默认开启专栏付费）
            if (data.channel.is_cost_fix && [58123, 62884].indexOf(data.channel.id) > -1) {
                this.props.dispatch({
                    type: 'LECTURE_SET_SINGLE_CHANNEL_PAY'
                })
            }
        }

        // 初始化邀请卡
        this.props.dispatch({
            type: 'SHARECARD_INIT',
            payload: {
                type: 'lecture',
                top: 50,
                role: data.role,
                id: data.lecture.id,
                is_resell: !!data.resell && ((data.resell.money * data.resell.percent / 100) > 1),
                title: data.resell && ((data.resell.money * data.resell.percent / 100) > 1) && '赚' + renderMoney(data.resell.money * data.resell.percent / 100)
            }
        });


        // 初始化通用组件
        this.onInitComponent(data);

        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: data.share_info.share_title,
                desc: data.share_info.share_description,
                imgUrl: data.share_info.share_icon,
                type: data.share_info.share_type,
                dataUrl: data.share_info.share_data_url,
                link: data.share_info.share_url,
                objectType: 'lecture',
                objectId: lecture_id
            }
        });

        // 检查优惠券
        const routerLocation = browserHistory.getCurrentLocation()

        let params = qs.parse(routerLocation.search.substr(1))

        if(!data.lecture_access.granted && !data.role.is_manager && !data.role.is_lecturer){
            const code = params.discount_code
            if(code){
                this.props.dispatch({
                    type: 'COUPON_RECEIVE',
                    payload: {
                        code: code,
                        scope: 'lecture',
                        target: data.lecture
                    }
                })
            }
        }

        if (params.st) {
            let source = params.st;
            switch (source) {
                case 'lzwk_article':
                    this.props.dispatch({
                        type: 'MTA_CLICK',
                        payload: 'path_wx_tolecture_closed'
                    });
                    break;
                default:
                    // return true
            }
        }

        if (params.tuhaopay){
            this.handlePayForNoCoupon();
        }

        this.backindex_method = () => {
            this.handleEntryAnimation();
        };

        if (!data.role.is_manager && !data.lecture_access.granted && !data.role.is_liveroom_vip) {
            this.handleAutoPaying(data)
        }

        window.addEventListener('scroll', this.backindex_method)

    }

    componentWillUnmount() {
        this.AutoPlaying && clearTimeout(this.AutoPlaying)
        this.ShareShow && clearTimeout(this.ShareShow);
        this.backindex_method && window.removeEventListener('scroll', this.backindex_method);
    }

    handleEntryAnimation() {
        const {width} = this.props.sharecard;

        this.ShareShow && clearTimeout(this.ShareShow);

        let self = this;
        this.show_method = function () {
            self.props.dispatch({
                type: 'SHARECARD_SLIDE',
                payload: 87
            })
        };
        if (width !== 87 && !isPC()) {
            this.ShareShow = setTimeout(this.show_method, 3000);
        }
        if ((document.body.scrollTop || document.documentElement.scrollTop) > 40) {
            this.setState({ shareCardTop: '10px' })
        } else {
            this.setState({ shareCardTop: '50px' })
        }

        if ((document.body.scrollTop || document.documentElement.scrollTop) > 168) {
            if (this.props.sharecard.animated && !isPC()) {
                if (width !== 26) {
                    this.props.dispatch({
                        type: 'SHARECARD_SLIDE',
                        payload: 26
                    })
                }
            } else {
                return true
            }

        }
    }

    //zxp-11.3
    handlePayForNoCoupon() {
        const routerLocation = browserHistory.getCurrentLocation();
        let params = qs.parse(routerLocation.search.substr(1));
        const code = params.discount_code;
        let data = this.props.lecture;
        const {showDiscountPayPanel} = this.props;
        if (code){
            window.location = `/lecture/${data.lecture.id}?tuhaopay=1`
        }else {
            this.props.dispatch({
                type: 'PAY_LECTURE',
                payload: {
                    params: {
                        product: 'pay_lecture',
                        lecture_id: data.lecture.id
                    },
                    success: (data) => {
                        this.props.dispatch({
                            type: 'LECTURE_SET_GRANTED',
                            payload: {
                                lecture_access: {
                                    granted: true
                                }
                            }
                        });
                        window.location = `/lecture/${data.lecture.id}/paysuccess${location.search}`;
                    }
                }
            });
        }
        this.props.dispatch({
            type: 'COUPON_SELECT_HIDE'
        });
        if (showDiscountPayPanel) {
            this.props.dispatch({
                type: 'LECTURE_HIDE_DISCOUNT_PAY_PANEL'
            });
        }
        this.props.dispatch({
            type: 'LECTURE_HIDE_PAY_PANEL'
        });
    }

    renderEditList() {
        let data = this.props.lecture;
        return [
            {
                blockContent: {
                    img: DataAna,
                    text: '数据分析',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/analysis`)
                    }
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: EditLecture,
                    text: '课程编辑',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/edit`)
                    }
                },
                hasContent: !data.lecture.is_relay
            },
            {
                blockContent: {
                    img: PushLecture,
                    text: '课程推送',
                    method: () => {
                        this.setState({
                            push_show: true
                        })
                    }
                },
                hasContent: true
            },
            {
                blockContent: {
                    img: PersonManage,
                    text: '嘉宾管理',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/invite`)
                    }
                },
                hasContent: !data.lecture.is_relay
            },
            {
                blockContent: {
                    img: StudentManage,
                    text: '学员管理',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/listeners`)
                    }
                },
                hasContent: !data.lecture.is_relay && data.lecture.lecture_type !== 'open_lecture' && data.lecture.lecture_type !== 'pay_channel'
            },
            {
                blockContent: {
                    img: Coupon,
                    text: '优惠券',
                    method: () => {
                        location.assign(`/liveroom/${data.liveroom.id}/coupon/list?scope=lecture&lecture_id=${data.lecture.id}`)
                    }
                },
                hasContent: !(data.lecture.lecture_type === 'password_lecture' || data.lecture.lecture_type === 'open_lecture' || data.lecture.is_relay || data.lecture.lecture_type === 'pay_channel')
            },
            {
                blockContent: {
                    img: limitImg,
                    text: '限时特价',
                    method: () => {
                        location.assign(`/lecture/${data.lecture.id}/edit/limit`)
                    }
                },
                hasContent: !(data.lecture.lecture_type === 'password_lecture' || data.lecture.lecture_type === 'open_lecture' || data.lecture.is_relay  || data.lecture.lecture_type === 'pay_channel')
            },
            {
                blockContent: {
                    img: RelaySetting,
                    text: '转载设置',
                    method: () => {
                        location.assign(`/relay_setting/lecture/${data.lecture.id}`)
                    }
                },
                hasContent: !data.lecture.is_relay && (data.lecture.lecture_type !== 'pay_channel') && (data.lecture.lecture_type !== 'password_lecture')
            }
        ]
    }

    handleAutoPaying(data) {
        const {lecture} = data;
        const routerLocation = browserHistory.getCurrentLocation()

        let query = qs.parse(routerLocation.search.substr(1))

        if (query && parseInt(query.autopaying) === 1){
            this.AutoPlaying = setTimeout(() => {
                this.props.dispatch({
                    type: 'PAY_LECTURE',
                    payload: {
                        params: {
                            product: 'pay_lecture',
                            lecture_id: lecture.id
                        },
                        success: () => {
                            window.location = `/lecture/${lecture.id}/paysuccess`;
                        }
                    }
                })
            }, 3000);
        }
    }

    render() {
        const {
            lecture,
            role,
            channel,
            showLecturer,
            hasBuyGift,
            lecture_access,
            channel_access,
            liveroom,
            category_info
        } = this.props.lecture;

        const {error} = this.props;
        const {confirmStyle, showLectureNew} = this.state;
        const urlParams = getJsonFromUrl();
        const isPresentPage = urlParams && urlParams.isPresent;

        if (error.showError) {
            return (
                <div className="lecture-page">
                    <WKError />
                </div>
            )
        }

        if (!this.props.lecture.initialized) {
            return <Page parent={this}>
                <div className="wk-inner-page main-page">
                    <Preload />
                </div>
            </Page>
        }

        //判断是否应该检查是否有优惠券
        const shouldCheckedCoupon = !role.is_liveroom_vip &&
            !(role.is_lecturer || role.is_manager) &&
            !(lecture_access.granted || (channel_access && channel_access.granted)) &&
            lecture.lecture_type !== 'password_lecture' &&
            lecture.lecture_type !== 'open_lecture' &&
            lecture.lecture_type !== 'pay_channel';
        //判断是否有优惠券
        const isCoupon = !role.is_liveroom_vip &&
            !(role.is_lecturer || role.is_manager) &&
            this.props.newCoupon.hasCoupon &&
            !(lecture_access.granted || (channel_access && channel_access.granted)) &&
            lecture.lecture_type !== 'password_lecture' &&
            lecture.lecture_type !== 'open_lecture' &&
            lecture.lecture_type !== 'pay_channel';

        //判断是否显示限时特价
        let isLimitPrice = lecture.limit_money && ((role.is_lecturer || role.is_manager) || !(lecture_access.granted || (channel_access && channel_access.granted)));

        // 判断特例
        let isSpecial = (channel && channel.id !== 58123 && channel.id !== 62884) || !channel;

        // 小程序支付参数分离
        const {wk_pay_source, mina_type, product, mina_product_id, inviter_id, st, sid, mina_discount_id} = urlParams

        return (
            <Page parent={this}>
                {this.state.isfromResell?
                    <div className="resell-from">
                        <div className="resell-mockup" >
                            <img onClick={()=>this.setState({isfromResell: false})} src={require('../images/activity/resell-marker@3x.png')} alt=""/>
                        </div>
                    </div>
                    : null}
                <Popup
                    show={this.state.isfromResell}
                    onRequestClose={e=>this.setState({isfromResell: false})}
                />
                <div className="lecturePage">
                <div className="lecture-page-control">
                    {!(lecture_access.granted || (channel_access && channel_access.granted) || role.is_manager) &&
                    <MinaPay discountId={mina_discount_id} paySource={wk_pay_source} minaType={mina_type} product={product} id={mina_product_id} inviterId={inviter_id} st={st} sid={sid}/>
                    }

                    <Dialog type="ios" buttons={this.state.NormalDialogBtns} show={this.state.showNormalDialog}>
                        点击"个人中心-优惠券"能更快捷进入"我的优惠券"页面填写优惠码哦
                    </Dialog>

                    <div className="lecture-page">
                        <WKDialog show={showLectureNew} onRequestClose={this.handleCloseNewDialog} confirmStyle={confirmStyle}>
                            <div className="lecture-new-dialog">
                                <div className="lct-title">
                                    <p>课程创建成功</p>
                                </div>
                                {category_info &&
                                <p className="lct-content">邀请好友使人气达到200以上，并且完善了类目信息，将有机会获得官方推荐</p>
                                }
                            </div>
                        </WKDialog>

                        {!(role.is_manager && role.is_lecturer) &&
                        <FollowLiveroom />
                        }

                        {((channel && channel.id !== 62884) || !channel) && !isPresentPage &&
                        <WKToIndex />
                        }

                        <LecturePayPanel />

                        <Pay />

                        {!hasBuyGift &&
                        <GiftDialogTips2 />
                        }

                        <GiftDialog />

                        {!isPresentPage && (urlParams && !urlParams.lfr) &&
                        <WKToShareCard top={this.state.shareCardTop} />
                        }

                        {(role.is_manager || role.is_relayer) &&
                        <div>
                            {this.state.push_show &&
                            <PushComponent type={'lecture'} target_id={lecture.id} handleHidePush={() => this.handleHidePush()}/>
                            }
                            {this.state.delete_show &&
                            <DeleteComponent type={'lecture'} target_id={lecture.id} liveroom_id={liveroom.id} handleHideDelete={() => this.handleHideDelete()}/>
                            }
                            <WKOperation editList={this.renderEditList()}/>
                        </div>
                        }

                        <LectureTopLiveroomBar type='lecture' />

                        <CoverImage />

                        {isLimitPrice && lecture.lecture_type !== 'pay_channel' &&
                        <LectureLimitPrice />
                        }

                        <DetailTitle complainType="lecture"/>

                        {isCoupon &&
                        <CouponBar type="lecture" target_id={lecture.id} />
                        }

                        {/*{(!role.is_manager && (channel && channel.is_member_goods) && role.is_member && !channel_access.granted) && false &&*/}
                        {/*<SVIPBar role={role} isCoupon={isCoupon} content={channel} type="lecture"/>*/}
                        {/*}*/}

                        {shouldCheckedCoupon &&
                        <CouponSelected type="lecture" target_id={lecture.id} payMethod={() => this.handlePayForNoCoupon()}/>
                        }

                        {lecture.has_discount && !(lecture_access.granted || (channel_access && channel_access.granted)) && lecture.lecture_type !== 'pay_channel' &&
                        <ReceiveCoupon />
                        }
                        {lecture.has_discount && !(lecture_access.granted || (channel_access && channel_access.granted)) && lecture.lecture_type !== 'pay_channel' && false &&
                        <AvailableCoupon scope="lecture" target={lecture} />
                        }

                        {lecture.is_preffered &&
                        <PopularBar prefferedReason={lecture.preffered_reason}/>
                        }

                        {lecture.listen &&
                        <AudioPlay audioUrl={lecture.listen} title={lecture.name} account_id={role.account_id} type={'lecture'} obj_id={lecture.id}/>
                        }

                        {lecture.description &&
                        <LectureTab />
                        }

                        <LectureLecturers />

                        {isSpecial &&
                        <div style={{marginBottom: '10px'}}>
                            <div onClick={this.onPopularBarClick}>
                                <LabelBar labelClassName={"no-margin-lecture "} labelFoot={this.onRenderRqb()} >人气榜</LabelBar>
                            </div>
                        </div>
                        }

                        <div className="lecture-labelbar">
                            {!role.is_manager && lecture.lecture_type !== 'pay_channel' && !isPresentPage && false &&
                            <LabelBar onCellClick={this.onDiscountBarClick}>
                                <div className="label-bar-icon-image">
                                    <img src={yhq} alt="优惠券通道"/>
                                </div>
                                优惠券通道
                            </LabelBar>
                            }

                            {/* {(!lecture.is_relay && !role.is_manager && !role.is_lecturer) && !isPresentPage &&
                            <LabelBar onCellClick={this.onOpenLectureChat}
                                      labelClassName={'no-margin '}>
                                <div className="label-bar-icon-image">
                                    <img src={zx} alt="课程咨询"/>
                                </div>
                                课程咨询
                            </LabelBar>
                            } */}


                            {this.state.isShowGift &&
                            <LabelBar onCellClick={this.onOpenGiftBar} labelClassName={"no-margin "}>
                                <div className="label-bar-icon-image">
                                    <img src={zs} alt="赠送好友"/>
                                </div>
                                赠送好友
                            </LabelBar>
                            }
                        </div>

                        <LectureLiveroomBar isPresentPage={isPresentPage}/>

                        {channel && channel.id &&
                        <LabelBar onCellClick={this.onChannelClick}
                                  labelClassName="margin-top-sub-1 ">所属专栏：<span
                            style={{color: '#576B95'}}>{channel.name}</span></LabelBar>
                        }

                        {lecture.can_public_relay && lecture_access.granted &&
                        <LabelBar labelFoot={lecture.relay_fee > 0 ? ("价格￥" + renderMoney(lecture.relay_fee)) : '免费转载'}
                                  labelClassName="margin-top-sub-1"
                                  onCellClick={this.onRelayBarClick}>我要转载</LabelBar>
                        }

                        {showLecturer &&
                        <LectureLecturersInput lectureId={lecture.id}/>
                        }

                        <LectureForm onCellClick={this.onDiscountBarClick} lectureId={lecture.id}/>

                        {false &&
                        <LectureListenTips />
                        }

                        {!isPresentPage &&
                        <DeepFocusBar liveroom_id={liveroom.id} object_id={lecture.id} object_type="fl_lecture"/>
                        }

                        <PageBottomText type='lecture' id={lecture.id}/>

                    </div>
                </div>
                </div>
                <LectureBottomNav isPresentPage={isPresentPage}/>
            </Page>
        )
    }


    onRenderRqb() {
        const {share_rank} = this.props.lecture;
        let result = share_rank.slice(0, 3).map((rank) => {
            return (
                <span className="portrait" key={rank.account.id}>
                    <img src={rank.account.avatar_url} alt={rank.account.nickname}/>
                </span>
            )
        });
        return result;
    }

    onInitComponent(data) {
        const {lecture, stats, lecture_access, channel_access, role, channel} = data;
        let isSpecial = (channel && channel.id !== 58123 && channel.id !== 62884) || !channel;

        // init CoverImage
        this.props.dispatch({
            type: 'COMPONENT_INIT_COVER_IMAGE',
            payload: {
                height: Math.min(480, document.body.clientWidth) * 0.57,
                image: lecture.cover_url,
                url: Config.BASE_URL
            }
        });

        // init DetailTitle
        let lectureTimeContent = TimeStream(lecture.start_timestamp);
        if (lecture.status === 'closed' && lecture.audio_length >= 5) {
            lectureTimeContent = '时长' + lecture.audio_length + "分钟";
        }

        let isShowGift = lecture.lecture_type === 'pay_lecture' && !lecture.is_relay && !role.is_manager
            && isSpecial && lecture.lecture_type !== 'pay_channel' && +lecture.id !== 5297593
        this.setState({isShowGift})
        this.props.dispatch({
            type: 'COMPONENT_INIT_DETAIL_TITLE',
            payload: {
                has_popular: lecture.is_preffered,
                money: (!lecture.limit_money && lecture.money && ((role.is_lecturer || role.is_manager)|| !(lecture_access.granted || (channel_access && channel_access.granted)))) ? renderMoney(lecture.money) : 0,
                tagClass: 'single-lecture',
                type: '单课',
                title: lecture.name,
                subTitle: lecture.subtitle,
                leftSide: lectureTimeContent,
                rightSide: stats.popular + '人气',
                shouldGiftShow: isShowGift,
                GiftMethod: this.onOpenGiftBar,
                id: lecture.id
            }
        })

        // init newLectrue Alert
        let urlParams = getJsonFromUrl();
        let key = 'lectureNew-' + lecture.id;
        if (!localStorage.getItem(key) && urlParams.fr && urlParams.fr === 'create_lecture' && (role.is_lecturer || role.is_manager)) {
            this.setState({showLectureNew: true});
            localStorage.setItem(key, true);
        }
    }

    onOpenGiftBar() {
        axios.post(`/api/gift/check_buy`).then((res) => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'LECTURE_SET_BUY_GIFT',
                    payload: res.data.data.has_buy,
                });
                const {hasBuyGift} = this.props;

                if (hasBuyGift) {
                    this.props.dispatch({
                        type: 'LECTURE_SHOW_GIFT_BAR'
                    });
                } else {
                    this.props.dispatch({
                        type: 'LECTURE_SHOW_GIFT_BAR_TIPS'
                    })
                }

                this.props.dispatch({
                    type: 'MTA_CLICK',
                    payload: 'lecture_giftclick'
                })

                this.props.dispatch({
                    type: 'MTA_CLICK',
                    payload: 'new_gift_entry_lecture'
                })
            }
        });
    }

    onOpenLectureChat() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_CHAT'
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_asksome'
        })
    }

    onRelayBarClick() {
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_sharetheclass'
        });
        // location.href = Config.MAIN_URL + '/lecture/relay_confirm?lecture_id=' + this.props.params.lecture_id
        location.assign(`/lecture/relay_confirm_new?id=${this.props.params.lecture_id}&type=lecture`)
    }

    onDiscountBarClick() {
        /*this.props.dispatch({
            type: 'LECTURE_SHOW_DISCOUNT_PANEL'
        })*/
        this.setState({
            showNormalDialog: true
        })
    }

    onPopularBarClick() {
        const {lecture} = this.props.lecture;
        if (this.props.lecture.role.is_lecturer || this.props.lecture.role.is_manager) {
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_ranklecturer'
            })
        } else {
            this.props.dispatch({
                type: 'MTA_CLICK',
                payload: 'lecture_rankstudent'
            })
        }
        window.location = `/lecture/${lecture.id}/sharerank`;
    }

    onChannelClick() {
        const {channel} = this.props.lecture;
        window.location = `/channel/${channel.id}`;
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_channel'
        })
    }

}

LecturePage.childContextTypes = {
    lecturePage: React.PropTypes.object
};

export default connect(state => ({
    role: state.lecture.role,
    lecture: state.lecture,
    error: state.error,
    hasBuyGift: state.lecture.hasBuyGift,
    sharecard: state.sharecard,
    newCoupon: state.newCoupon
}))(LecturePage)



// WEBPACK FOOTER //
// ./src/pages/LecturePage.js